import { Link } from "react-router-dom";
import { Linkedin, Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { LOGO_URL, COMPANY } from "../lib/constants";

export default function Footer() {
  return (
    <footer className="bg-[#0B0F19] text-slate-300 pt-20 pb-10 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 pb-16 border-b border-white/10">
          <div className="lg:col-span-5">
            <img src={LOGO_URL} alt="Medstry" className="h-10 w-auto object-contain bg-white px-3 py-1.5 inline-block" />
            <p className="mt-6 text-slate-400 text-[15px] leading-relaxed max-w-md">
              Brand Lifecycle Management for India's pharma & healthcare leaders. Where others see
              maturity, we see untapped potential.
            </p>

            <div className="mt-8 space-y-3 text-sm text-slate-300">
              <div className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-teal-300 mt-1 shrink-0" strokeWidth={1.5} />
                <span>{COMPANY.address}</span>
              </div>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-white">
                <Mail className="h-4 w-4 text-teal-300" strokeWidth={1.5} />
                <span>{COMPANY.email}</span>
              </a>
              <a href={`tel:${COMPANY.phone}`} className="flex items-center gap-3 hover:text-white">
                <Phone className="h-4 w-4 text-teal-300" strokeWidth={1.5} />
                <span>{COMPANY.phone}</span>
              </a>
            </div>

            <div className="mt-6 flex items-center gap-3">
              <a
                href={COMPANY.social.linkedin}
                target="_blank"
                rel="noreferrer"
                data-testid="social-linkedin"
                className="h-9 w-9 inline-flex items-center justify-center border border-white/15 hover:bg-white/5"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href={COMPANY.social.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="social-instagram"
                className="h-9 w-9 inline-flex items-center justify-center border border-white/15 hover:bg-white/5"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href={COMPANY.social.facebook}
                target="_blank"
                rel="noreferrer"
                data-testid="social-facebook"
                className="h-9 w-9 inline-flex items-center justify-center border border-white/15 hover:bg-white/5"
              >
                <Facebook className="h-4 w-4" />
              </a>
            </div>
          </div>

          <FooterCol
            title="Solutions"
            items={[
              { label: "For Large Pharma", href: "/#solutions" },
              { label: "For Mid-Size & SMEs", href: "/#solutions" },
              { label: "For MNCs India Entry", href: "/#solutions" },
              { label: "Delta Field Force Model", href: "/#approach" },
            ]}
          />
          <FooterCol
            title="Company"
            items={[
              { label: "About Medstry", href: "/about" },
              { label: "Our Approach", href: "/approach" },
              { label: "Why Choose Us", href: "/impact" },
              { label: "Blog", href: "https://blog.medstry.in", external: true },
              { label: "Resources & Insights", href: "/resources" },
            ]}
          />
          <FooterCol
            title="Connect"
            items={[
              { label: "Contact Us", href: "/#contact" },
              { label: "Portfolio Health Quiz", href: "/quiz" },
              { label: COMPANY.email, href: `mailto:${COMPANY.email}` },
              { label: COMPANY.phone, href: `tel:${COMPANY.phone}` },
            ]}
          />
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Medstry Healthcare Pvt Ltd. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="/resources" className="hover:text-white">Privacy Policy</a>
            <a href="/resources" className="hover:text-white">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div className="lg:col-span-2">
      <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-5">{title}</div>
      <ul className="space-y-3 text-sm">
        {items.map((it) => (
          <li key={it.label}>
            {it.external ? (
              <a href={it.href} target="_blank" rel="noreferrer" className="text-slate-300 hover:text-white">
                {it.label}
              </a>
            ) : it.href.startsWith("/") && !it.href.includes("#") ? (
              <Link to={it.href} className="text-slate-300 hover:text-white">
                {it.label}
              </Link>
            ) : (
              <a href={it.href} className="text-slate-300 hover:text-white">
                {it.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
